// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"f508f261","798":"ea09ff6f","956":"111ae6a1"}[chunkId] + ".chunk.js";
};